import type { LoggerAdapter } from './logger-adapter.interface.js';

export class LocalStorageAdapter implements LoggerAdapter {
  public static readonly LOCAL_STORAGE_KEY = 'FLUX_CONTROL.DEBUG';

  public getPattern(): string | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }

    return localStorage.getItem(LocalStorageAdapter.LOCAL_STORAGE_KEY);
  }

  public enable(pattern: string): void {
    if (typeof localStorage === 'undefined') {
      return;
    }

    localStorage.setItem(LocalStorageAdapter.LOCAL_STORAGE_KEY, pattern ?? '*');
  }

  public disable(pattern?: string): void {
    if (typeof localStorage === 'undefined') {
      return;
    }

    if (pattern) {
      const oldPattern = this.getPattern();
      if (!oldPattern) {
        return;
      }

      localStorage.setItem(
        LocalStorageAdapter.LOCAL_STORAGE_KEY,
        oldPattern
          .split(',')
          .filter((ptt) => ptt !== pattern)
          .join(','),
      );
    } else {
      localStorage.removeItem(LocalStorageAdapter.LOCAL_STORAGE_KEY);
    }
  }
}
